import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { SitePaddingMin } from '@helpers/grid';
import { Layers } from '@helpers/layers';
import scrollbars from '@helpers/scrollbars';
import { h2, paragraphMedium } from '@helpers/typography';
import FloatingActionButton from '@stories/Components/Buttons/FloatingActionButton/FloatingActionButton';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled.section `
  position: relative;
  display: flex;
  background: ${brand.white};
  flex-direction: column;
  max-height: 100%;
  max-width: 862px;
`;
const Header = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: ${fluid(SitePaddingMin, 40)};
`;
const Inner = styled.div `
  ${scrollbars}

  overflow-y: auto;
  padding: ${fluid(28, 64)} ${fluid(SitePaddingMin, 40)} ${fluid(SitePaddingMin, 40)};
`;
const Title = styled.h2 `
  ${h2}

  align-self: flex-start;
  background: ${brand.yellow};
  clip-path: polygon(0% 0%, 100% 0%, calc(100% - 40px) 100%, 0% 100%);
  margin: 0;
  padding: 16px 72px 16px ${fluid(SitePaddingMin, 40)};
`;
const Content = styled.p `
  ${paragraphMedium}
`;
const FormWrapper = styled.div ``;
const CtaWrapper = styled(m.div) `
  --spacingX: ${SitePaddingMin}px;
  --spacingY: 14px;

  position: fixed;
  bottom: var(--spacingY);
  right: var(--spacingX);
  z-index: 1001;
`;
const Cta = styled(FloatingActionButton) `
  z-index: ${Layers.Modal + 1};
`;
const LogoWrapper = styled.div `
  height: ${fluid(36, 56)};
`;
const Logo = styled.img `
  display: block;
  height: 100%;
  object-fit: contain;
  object-position: center right;
`;
const ModalFormStyles = {
    Container,
    Content,
    CtaWrapper,
    Cta,
    FormWrapper,
    Header,
    Inner,
    Logo,
    LogoWrapper,
    Title,
};
export default ModalFormStyles;
